import React from 'react';
import { Card, CardContent } from '../ui/Card';
import { Thermometer, Wind, Briefcase, Radio, Headphones } from 'lucide-react';
export function BenefitsSection() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="mx-auto max-w-3xl text-center mb-16" data-id="element-34">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl font-serif" data-id="element-35">
            Qué vas a encontrar adentro
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-36">
            Tu botiquín emocional digital: 21 técnicas de alivio inmediato +
            audiolibro incluido.
          </p>
        </div>

        <div className="mx-auto max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-37">
          <Card className="border-l-4 border-l-blue-500 hover:shadow-md transition-shadow" data-id="element-38">
            <CardContent className="flex items-start p-6" data-id="element-39">
              <div className="mr-4 mt-1" data-id="element-40">
                <Thermometer className="h-6 w-6 text-blue-500" data-id="element-41" />
              </div>
              <div data-id="element-42">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-43">
                  El Protocolo de Shock Térmico
                </h3>
                <p className="text-slate-600" data-id="element-44">
                  Cómo usar la temperatura para resetear tu nervio vago
                  instantáneamente.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-l-4 border-l-purple-500 hover:shadow-md transition-shadow" data-id="element-45">
            <CardContent className="flex items-start p-6" data-id="element-46">
              <div className="mr-4 mt-1" data-id="element-47">
                <Wind className="h-6 w-6 text-purple-500" data-id="element-48" />
              </div>
              <div data-id="element-49">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-50">
                  21 Técnicas Tácticas
                </h3>
                <p className="text-slate-600" data-id="element-51">
                  Desde la respiración antipánico hasta el anclaje sensorial
                  para momentos críticos.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-l-4 border-l-orange-500 hover:shadow-md transition-shadow" data-id="element-52">
            <CardContent className="flex items-start p-6" data-id="element-53">
              <div className="mr-4 mt-1" data-id="element-54">
                <Briefcase className="h-6 w-6 text-orange-500" data-id="element-55" />
              </div>
              <div data-id="element-56">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-57">
                  Guía para la Oficina
                </h3>
                <p className="text-slate-600" data-id="element-58">
                  Cómo calmarte en una reunión o en el trabajo sin que nadie se
                  entere.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-l-4 border-l-green-500 hover:shadow-md transition-shadow" data-id="element-59">
            <CardContent className="flex items-start p-6" data-id="element-60">
              <div className="mr-4 mt-1" data-id="element-61">
                <Radio className="h-6 w-6 text-green-500" data-id="element-62" />
              </div>
              <div data-id="element-63">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-64">
                  El Escudo Anti-Noticias
                </h3>
                <p className="text-slate-600" data-id="element-65">
                  Cómo proteger tu mente del ruido económico y la incertidumbre
                  actual.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-l-4 border-l-indigo-500 hover:shadow-md transition-shadow md:col-span-2" data-id="element-66">
            <CardContent className="flex items-start p-6" data-id="element-67">
              <div className="mr-4 mt-1" data-id="element-68">
                <Headphones className="h-6 w-6 text-indigo-500" data-id="element-69" />
              </div>
              <div data-id="element-70">
                <div className="flex items-center gap-2 mb-1" data-id="element-71">
                  <h3 className="text-lg font-bold text-slate-900" data-id="element-72">
                    🎧 Audiolibro Completo
                  </h3>
                  <span className="text-xs font-semibold bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-73">
                    INCLUIDO
                  </span>
                </div>
                <p className="text-slate-600" data-id="element-74">
                  Escuchá las técnicas narradas para usarlas en el colectivo,
                  antes de dormir o cuando más lo necesités. Sin leer, sin
                  esfuerzo.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}